import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import api from './api'
import settings from './settings'
import app from './app'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        user,
        settings,
        api,
        app,
    },
    state: {},
    mutations: {
        SET_USER(state, user) {
            console.log('set User')
            state.user = user
        },
    },
    actions: {},
})